import AmountToPay from './amount_to_pay';

export default AmountToPay;
